import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common/common.service';
import { LocalStorageKey } from 'src/app/enums/local-storage-key.enum';
import { ConfigService } from 'src/app/services/config/config.service';
import { MetricsService } from 'src/app/services/metrics/metrics.service';
import { DeviceService } from 'src/app/services/device/device.service';
import { HostListener } from '@angular/core';

@Component({
	selector: 'vtr-modal-license-agreement',
	templateUrl: './modal-license-agreement.component.html',
	styleUrls: ['./modal-license-agreement.component.scss'],
})
export class ModalLicenseAgreementComponent implements OnInit {
	public checkedLicense = false;
	public checkedPrivacy = false;
	public disableLetsGo = true;
	public licenseUrl = 'https://support.lenovo.com/us/en/solutions/ht100141';
	public textDirection: string;
	private policyLink = 'https://www.lenovo.com/privacy';
	constructor(
		public activeModal: NgbActiveModal,
		private commonService: CommonService,
		private metricsService: MetricsService,
		private configService: ConfigService,
		private deviceService: DeviceService
	) {}

	ngOnInit() {
		this.disableLetsGo = !this.checkedLicense || !this.checkedPrivacy;
		this.deviceService.getMachineInfo().then((value: any) => {
			const lang = value.locale.toLowerCase();
			this.textDirection = lang === 'ar' || lang === 'he' ? 'rtl' : null;
		});
	}

	onLicenseCheckedChange($event) {
		this.checkedLicense = $event;
		this.disableLetsGo = !this.checkedLicense || !this.checkedPrivacy;
	}

	onPrivacyCheckedChange($event) {
		this.checkedPrivacy = $event;
		this.disableLetsGo = !this.checkedLicense || !this.checkedPrivacy;
	}

	onClickClose() {
		const win: any = window;
		if (win.VantageStub && win.VantageStub.exitApp) {
			win.VantageStub.exitApp();
		}
		this.activeModal.close('close');
	}

	onClickLetsGo() {
		this.commonService.setLocalStorageValue(LocalStorageKey.LicenseAgreementAccepted, true);
		this.metricsService.sendAppActivationEvent();
		this.activeModal.close('close');
	}

	onClickLicenseLink(event) {
		window.open(this.licenseUrl, '_blank');
		event.stopPropagation();
		event.preventDefault();
	}

	onClickPrivacyLink(event) {
		window.open(this.policyLink, '_blank');
		event.stopPropagation();
		event.preventDefault();
	}

	@HostListener('window: focus')
	onFocus(e): void {
		const doc = document.querySelector(
			'#cb-accept-license-agreement_checkbox-input'
		) as HTMLElement;
		doc.focus();
	}
}
